/**
 * Supabase env helpers. Publishable key is read from NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY.
 * Use this for all user-facing clients (browser + server with cookies) so RLS sees auth.uid().
 * Server Actions that mutate data after verifying the user should use SUPABASE_SECRET_KEY
 * (createServiceRoleClient) — see lib/supabase/server.ts.
 */
export function getSupabaseUrl(): string | undefined {
  return process.env.NEXT_PUBLIC_SUPABASE_URL?.trim() || undefined;
}

export function getSupabasePublishableKey(): string | undefined {
  return process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY?.trim() || undefined;
}
